<template>
    <div class="main mt15">
        <Row>
            <Col span="4" class="layout-menu-left">
            <Menu width="auto" :active-name="active" @on-select="change">
                <MenuItem name="1">
                我的投保单
                </MenuItem>
                <MenuItem name="2">
                我的保单
                </MenuItem>
                <MenuItem name="3">
                我的批改单
                </MenuItem>
            </Menu>
            </Col>
            <Col span="20">
                <router-view class="mt15"></router-view>
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                active: '1',
            }
        },
        created(){
            this.changeRoute(this.$route.name)
        },
        methods: {
            change (value) {
                let url = "";
                if (value == '1') {
                    url = "/my/customizedTPL/insurance";
                } else if (value == '2') {
                    url = "/my/customizedTPL/policy";
                } else if (value == '3') {
                    url = "/my/customizedTPL/rider";
                }
                url != this.$route.path && this.$router.push({
                    path: url,
                    query: this.$route.query
                })
            },
            changeRoute (routeName) {
                if (routeName == "insuranceTPL") {
                    this.active = "1";
                } else if (routeName == "policyTPL") {
                    this.active = "2";
                } else if (routeName == "riderTPL") {
                    this.active = "3";
                }
            }
        },
        watch: {
            '$route.name' (v) {
                this.changeRoute(this.$route.name);
                console.log(v,'0000000000')
            }
        }
    }
</script>
<style scoped>
    .main {
        background: #fff;
        /* margin-top: 102px; */
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift.vue